<template>
    <div class="product-item" v-if="categoryData.length > 0 " @click="GTMProdCatClick(name)"> 
        <router-link :to="{ name:'ProductDetails_' + currentLangName(), params: {product_slug: product_slug, product_category_slug: categoryData[0].slug}}" class="product-item__prodlink">                             
            <img :srcset="srcset" :alt="name" :title="name" class="img-fluid product-item__img" v-if="(srcset!='no-image' || src!='no-image') && (imgPack == null || imgPack == undefined)" 
            sizes="(max-width: 767px) 130px, 286px" :src="src_url + '/' + src" />
            <!-- packImg -->
            <img :srcset="imgPack.image.srcset" :alt="name" :title="name" class="img-fluid product-item__img packImg" v-else-if="(srcset!='no-image' || src!='no-image') && (imgPack != null || imgPack != undefined)" 
            sizes="(max-width: 767px) 130px, 286px" :src="src_url + '/' + imgPack.image.cache.w286h440" />
            <!-- noimage -->
            <img v-else src='@/assets/images/noimage/product-no-image.svg' :alt="name" :title="name" class="img-fluid product-item__img" />
            <div class="product-item__data">            
                <div class="name">{{  name }}</div>                   
                <div class="category" v-if="fixCategory==null || fixCategory == undefined">                    
                    <span v-for="categoryName in categoryData" :key="categoryName.id">
                        {{ categoryName.name }}
                    </span>
                </div>  
                <div class="category" v-else>                    
                    {{fixCategory}}
                </div>                
                <div class="btn btn--more"></div>
            </div>
        </router-link>     
    </div>
</template>

<script>
export default {
    data(){
        return {
            src_url: process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME
        }
    },
    props: ['name', 'id', 'product_slug', 'srcset', 'src', 'fixCategory', 'imgPack'],
    computed:{                      
        categoryData(){                                 
            let categoryArray = this.$store.getters.getProducstCategory;                   
            return this.getCategoryData(this.id, categoryArray  )
        }        
    },
    methods:{
        GTMProdCatClick(product){          
            this.setDataLayer('product_details', product, '')                  
        } 
    } 
}
</script>